import type { ReactNode } from 'react'
import type { Projection, ResolutionStatus } from '@v2/sdk'

/** The one persistent piece of game information: whose turn, what to do, how far along. */
export function TurnChip({ projection, status, resolution, updates }: { projection: Projection; status?: ReactNode; resolution?: ResolutionStatus; updates?: ReactNode }) {
  const active = projection.players.find(player => player.id === projection.activePlayer)
  const mine = active !== undefined && active.id === projection.viewer
  const progress = projection.progress
  const percent = progress ? Math.min(100, Math.max(0, 100 * progress.current / Math.max(1, progress.total))) : 0
  const heading = projection.outcome ? 'Game over' : mine ? 'Your turn' : active ? `${active.name}’s turn` : 'Waiting'
  return <section className={`tt-turn${mine ? ' is-mine' : ''}`} aria-label="Current turn" aria-live="polite">
    <div className="tt-turn-row">
      <span className="tt-turn-dot" style={{ background: active?.color }} aria-hidden="true"/>
      <strong>{heading}</strong>
      <span className="tt-turn-phase">{projection.phase}</span>
      {progress && <span className="tt-turn-progress" title={progress.label}>{progress.current}<span aria-hidden="true">/</span><span className="tt-sr-only">of</span>{progress.total}</span>}
    </div>
    {resolution && <p className="tt-resolving" role="status" data-phase={resolution.phase} data-deadline={resolution.deadline}><span className="tt-resolving-spinner" aria-hidden="true"/>{resolution.label}</p>}
    {!projection.outcome && !resolution && <p className="tt-turn-instruction">{projection.instruction}</p>}
    {projection.status && <p className={`tt-game-status${projection.status.warning ? ' is-warning' : ''}`}>{projection.status.label}</p>}
    {(status || updates) && <div className="tt-turn-status">{status}{updates}</div>}
    {progress && <span className="tt-turn-track" aria-hidden="true"><span style={{ width: `${percent}%` }}/></span>}
  </section>
}
